import Component from '@glimmer/component';
import { action } from '@ember/object';

import MiscUtils, { getLinkForPost } from 'mewe/utils/miscellaneous-utils';

export default class MwCopyLink extends Component {
  @action
  click() {
    const link = getLinkForPost(this.args.post);
    MiscUtils.copyToClipboard(link);
  }
}
